import React from "react";

export const ERROR_EMPTY_SUBSCRIPTIONS_MESSAGE = <React.Fragment>У вас ещё нет подписок. Чтобы подписаться на мод,<br />на странице мода нажмите на кнопку:</React.Fragment>;
export const ERROR_EMPTY_SUBSCRIPTIONS_BUTTON = 'К списку модов';